/**
 * Reimbursement Detail route entry.
 *
 * Angular Default module uses the SAME detail component as Resident
 * (`ResidentEditNewComponent` with `pagetype=default-detail`). React mirrors that:
 * this page is a thin wrapper around the shared `ResidentDetailPage`.
 *
 * Lists stay separate (`ReimbursementsListPage` vs `ResidentListPage`).
 */
import { ResidentDetailPage } from '@/features/resident/pages/ResidentDetailPage'

export function ReimbursementsDetailPage() {
  return <ResidentDetailPage pageType="default-detail" />
}
